<template>
  <v-autocomplete
    class="autocomplete"
    v-bind:attach="attach"
    v-bind:clearable="clearable"
    v-bind:disabled="disabled"
    v-bind:hide-details="hideDetails"
    v-bind:item-text="optionTitleKey"
    v-bind:item-value="optionValueKey"
    v-bind:items="options"
    v-bind:no-data-text="noDataText"
    v-bind:placeholder="placeholder"
    v-bind:required="required"
    v-bind:return-object="returnObject"
    v-bind:value="value"
    v-bind="inputAttributes"
    v-on:input="onInput"
  >
    <template v-slot:label>
      <span class="autocomplete__title">{{ title }}</span>
    </template>
    <template v-slot:no-data>
      <slot name="no-data" />
    </template>
  </v-autocomplete>
</template>
<script>

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Поле ввода с автодополнением.
 * @type {Vue}
 */
export default {
  computed: {
    inputAttributes() {
      const attributes = {};
      if (this.allowedPass !== true) {
        /**
         * Запретить автозаполнение для LastPass.
         * @link https://support.lastpass.com/help/how-do-i-prevent-fields-from-being-filled-automatically
         */
        attributes['data-lpignore'] = 'true';
      }
      if (this.name) {
        attributes.name = this.name;
      }
      return attributes;
    },
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {any} value
     * @returns {void}
     */
    onInput(value) {
      this.$emit(NAME_EVENT_INPUT, value);
    },
  },
  name: 'InputAutocomplete',
  props: {
    /**
     * @description Разрешить вставку пароля.
     * @type {boolean}
     */
    allowedPass: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description К какому элементу прикреплять.
     * @type {any}
     */
    attach: {
      default: () => false,
      type: [Boolean, Object],
    },
    /**
     * @description Отчищаемый.
     * @type {boolean}
     */
    clearable: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Деактивировано.
     * @type {boolean}
     */
    disabled: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Скрывать детали.
     * @type {boolean|string}
     */
    hideDetails: {
      default: () => false,
      type: [Boolean, String],
    },
    /**
     * @description Уникальное имя элемента формы.
     * @type {String}
     */
    name: {
      required: false,
      default: () => false,
      type: [String, Boolean],
    },
    /**
     * @description Текст при отсутствии данных.
     * @type {string}
     */
    noDataText: {
      default: () => '',
      type: String,
    },
    /**
     * @description Опции.
     * @type {any[]}
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Ключ заголовка опции.
     * @type {string}
     */
    optionTitleKey: {
      default: () => 'title',
      type: String,
    },
    /**
     * @description Ключ значения опции.
     * @type {string}
     */
    optionValueKey: {
      default: () => 'value',
      type: String,
    },
    /**
     * @description Текст заполнитель.
     * @type {string}
     */
    placeholder: {
      default: () => '',
      type: String,
    },
    /**
     * @description Поле обязательно для заполнения.
     * @type {boolean}
     */
    required: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Возвращать выбранный объект, а не значение по ключу значения опции.
     * @type {boolean}
     */
    returnObject: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: {
      required: true,
      type: String,
    },
    /**
     * @description Выбранное значение.
     * @type {any}
     */
    value: { required: true },
  },
};
</script>
<style scoped>
.autocomplete .autocomplete__title {
  color: var(--unfocus-color);
}
</style>
